import React from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'

import { saveAs } from 'file-saver'

import { useForm, FormContext, Controller } from 'react-hook-form'

import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'
import useSnackbar from 'hooks/useSnackbar'
import useGovernanceProjectNameDpo from 'hooks/useGovernanceProjectNameDpo'

import { Download as DownloadIcon } from 'react-feather'

import { FileUploadInput } from 'components'
import { JourneyRecaptcha } from 'views/Suppliers/Journey/components'

import * as service from 'service'
import helpers from 'helpers'

import useStyles from './styles'
import schema from './schema'
import constants from 'constants/index'

const AttachNominationForm = () => {
  const snackbar = useSnackbar()
  const styles = useStyles()

  const { setCurrentStep } = useJourneyWhiteLabel()
  const {
    governanceProjectTemplate,
    governanceProjectCompany,
    setLoading,
    recaptcha,
    recaptchaRef,
    handleAcceptedRecaptcha,
    disableRecaptcha,
    resetRecaptcha,
  } = useGovernanceProjectNameDpo()

  const companyDocument = helpers.regex.onlyNumbersAndLetters(
    governanceProjectCompany?.company?.document,
  )

  const form = useForm({
    validationSchema: schema,
    defaultValues: {
      complements: '',
      document: null,
    },
  })

  const handleDownload = async () => {
    if (!governanceProjectCompany?.document?.url) return
    setLoading(true)

    try {
      const response = await fetch(governanceProjectCompany?.document?.url)
      const blob = await response.blob()

      saveAs(
        new Blob([blob], { type: blob.type }),
        governanceProjectCompany?.document?.name,
      )
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Ocorreu um erro ao baixar o relatório',
      })
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      await service.dponet.governanceProjectStage.attachNomination({
        token: governanceProjectTemplate?.token,
        companyDocument,
        attachNomination: { ...data, recaptcha },
      })

      await service.dponet.governanceProjectStage.sendToReview({
        token: governanceProjectTemplate?.token,
        companyDocument,
      })
      setCurrentStep((prevStep) => prevStep + 1)
    } catch (error) {
      console.error('Error submitting form:', error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      resetRecaptcha()
      setLoading(false)
    }
  }

  return (
    <FormContext {...form}>
      <form id="name-dpo-form" onSubmit={form.handleSubmit(onSubmit)}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Controller
              as={
                <TextField
                  error={!!form.errors.complements}
                  helperText={form.errors.complements?.message}
                  fullWidth
                  label="Nome da Diretoria Executiva"
                />
              }
              control={form.control}
              name="complements"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              endIcon={<DownloadIcon />}
              fullWidth
            >
              BAIXAR MODELO DA FICHA DE INDICAÇÃO
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              className={styles.typographySubtitle}
            >
              Anexe a ficha de indicação no espaço abaixo
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FileUploadInput
              controlName="document"
              accept={constants.validations.PDF_FILE_TYPE}
            />
          </Grid>
          <Grid item xs={12} className={styles.recaptchaContainer}>
            <JourneyRecaptcha
              recaptchaRef={recaptchaRef}
              onChange={handleAcceptedRecaptcha}
              onExpired={disableRecaptcha}
              onErrored={disableRecaptcha}
            />
          </Grid>
        </Grid>
      </form>
    </FormContext>
  )
}

export default AttachNominationForm
